import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { AbstractMessageDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractMessageDialogProperties";
import * as PIXI from "pixi.js";
/**
 * MessageDialogProperties.ts
 */
export class MessageDialogProperties extends AbstractMessageDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.titleFieldProperties.position = new PIXI.Point(512, 290);
        this.titleFieldProperties.size = new PIXI.Point(800, 160);
        this.messageFieldProperties.position = new PIXI.Point(512, 410);
        this.messageFieldProperties.size = new PIXI.Point(800, 350);
        this.confirmButtonProperties.position = new PIXI.Point(340, 775);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(200, 145);
        this.confirmButtonProperties.textFieldProperties.setHorizontalAlign(ControlConstants.CENTER);
        this.confirmButtonProperties.textFieldProperties.setVerticalAlign(ControlConstants.CENTER);
        this.confirmButtonProperties.textFieldOffset.set(0, -8);
    }
}
